var translation = {
	"Your profile": "プロフィール",
	"View profile": "プロフィールを表示",
	"Personal information": "個人情報",
	"Community information": "コミュニティ情報",
	"Workplace information": "勤務先情報",
	"Email Preferences Center": "E メール設定センター",
	"Builder ID privacy & data": "ビルダー ID のプライバシーとデータ",
	"About profiles": "プロフィールについて",
	"Welcome back": "おかえりなさい",
	"Personal email address": "個人用 E メールアドレス",
	Email: "E メール",
	Edit: "編集",
	Save: "保存",
	"All fields marked with an asterisk (*) are required.": "アスタリスク (*) が付いている項目はすべて必須です。",
	"Choose an option": "項目を選択",
	"Visible to others": "他のユーザーに表示",
	"Fields in this section will be visible to others.": "このセクションのフィールドは他のユーザーにも表示されます。",
	"Display name": "表示名",
	Alias: "エイリアス",
	Bio: "略歴",
	"Github profile": "Github プロファイル",
	"Youtube profile": "YouTube プロファイル",
	"Facebook profile": "Facebook プロファイル",
	"re:Post profile": "re:Post プロファイル",
	"Dev:to profile": "Dev:to プロファイル",
	"Link to blog": "ブログへのリンク",
	"LinkedIn profile": "LinkedIn プロファイル",
	"X profile": "X プロファイル",
	Social: "SNS",
	Username: "ユーザー名",
	"Add social link": "ソーシャルメディアのリンクを追加",
	"Interest & background information": "関心事項と背景情報",
	"Manage your interests and other information that are used in recommending content. ": "コンテンツを提案する際に使用する関心事項やその他の情報を管理します。",
	Interests: "関心事項",
	"Search interests": "関心事項を検索する",
	Country: "国",
	"State/province": "都道府県",
	"Role type": "役割の種類",
	"Industry focus": "フォーカスする業界",
	"Level of AWS usage": "AWS の使用レベル",
	"Use case focus": "フォーカスするユースケース",
	"Manage your work information to accurately represent your organization.": "組織を正確に表すように勤務情報を管理します。",
	"Business email address": "仕事用 E メールアドレス",
	"Business phone number": "勤務先電話番号",
	"Company website": "会社のウェブサイト",
	"Job title": "役職名",
	"Company name": "会社名",
	"Company type": "会社の種類",
	"Company size": "会社の規模",
	"Project timeline": "プロジェクトのタイムライン",
	"Powered by Profile": "プロファイルを活用する",
	About: "概要",
	"Make your profile": "プロフィールを作成する",
	Profile: "プロファイル",
	"Get started": "開始する",
	"Manage your information and preferences that are used to improve select AWS experiences.": "一部の AWS エクスペリエンスの向上に使用される情報や設定を管理します。",
	"Sign in/Get started": "サインイン/使用開始",
	"Key things to know": "重要事項",
	"Access experience": "利用状況を確認する",
	"Control your data": "データを管理する",
	"Read about privacy": "プライバシーポリシーを読む",
	"Email preference center": "E メール設定センター",
	"This field is required.": "このフィールドは必須です。",
	"Your profile helps improve your interactions with select AWS experiences.": "プロファイルを利用すると、一部の AWS エクスペリエンスで操作が向上します。",
	City: "市",
	"Page topics": "ページトピック",
	"User information": "ユーザー情報",
	"Full name": "フルネーム",
	Discard: "破棄",
	Link: "リンク",
	"Short bio": "略歴",
	"Add interest": "関心を追加",
	"Unsaved changes": "未保存の変更",
	"Please make a change before saving.": "保存する前に変更してください。",
	"Changes could not be saved.": "変更を保存できませんでした。",
	"Your information has been saved.": "情報が保存されました。",
	"Your new Profile Picture": "新しいプロフィール写真",
	"Profile Picture": "プロフィール写真",
	"Your profile picture makes you easily recognizable and shows when you're signed in.": "プロフィール写真を使うと、見分けてもらいやすくなります。また、サインイン時に表示されます。",
	Cancel: "キャンセル",
	"Save profile picture": "プロフィール写真を保存する",
	"Change profile picture": "プロフィール写真を変更する",
	"Remove profile picture": "プロフィール写真を削除する",
	Zoom: "ズーム",
	"20MB maximum file size, only .jpg, .jpeg, .png, .webp file types supported": "最大ファイルサイズは 20 MB、.jpg、.jpeg、.png、.webp ファイルタイプのみがサポートされています",
	"Drag and drop": "ドラッグアンドドロップ",
	"or browse files": "または参照",
	"or Browse files (browse files is link to open files)": "またはファイルを参照 (ファイルの参照はファイルを開くリンクです)",
	"There was an error processing your profile picture, please try again.": "プロフィール写真の処理中にエラーが発生しました。もう一度お試しください。",
	"Your profile picture has been updated.": "プロフィール写真が更新されました。",
	"File size above 20MB.": "ファイルサイズが 20 MB を超えています。",
	"Invalid file type.": "ファイルタイプが無効です。",
	"An error occurred.": "エラーが発生しました。",
	"Click or drag file to this area (backup from community in case we change our mind on drag and drop text)": "ファイルをクリックするか、この領域にファイルをドラッグしてください (ドラッグアンドドロップテキストが変更される場合に備えて、コミュニティからバックアップ)",
	"I agree to the terms of the <a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "<a href=#1 target=\"_blank\" rel=\"noopener noreferrer\">AWS カスタマーアグリーメント</a> 、および<a href=#2 target=\"_blank\" rel=\"noopener noreferrer\">個人情報の収集と使用に関するステートメント</a> の条件に同意します。",
	"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf": "https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf",
	"Sign into your profile": "プロファイルにサインイン",
	"Sign in": "サインイン",
	"First name": "名",
	"Last name": "姓",
	"Phone number": "電話番号",
	"Postal code": "郵便番号",
	"Business address": "会社の住所",
	Select: "選択",
	"Enter text": "テキストを入力",
	"Business Interests": "ビジネス目的",
	"Personal Interests": "個人目的",
	"Manage your email through <a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS Builder ID</a>": "<a class=\"link\" href=\"https://profile.aws.amazon.com/#/profile/details\" rel=\"noopener noreferrer\" target=\"_blank\">AWS ビルダー ID</a> を使用して E メールを管理する",
	"Manage information that other members in the community will see when you create content on <a class=\"link\" href=\"https://builder.aws.com\">Builder Center</a> or leave comments on <a class=\"link\" href=\"https://aws.amazon.com/blogs\">AWS Blogs</a>.": "<a class=\"link\" href=\"https://builder.aws.com\" target=\"_blank\" rel=\"noopener noreferrer\">Builder Center</a> でコンテンツを作成したり、<a class=\"link\" href=\"https://aws.amazon.com/blogs\" target=\"_blank\" rel=\"noopener noreferrer\">AWS ブログ</a>にコメントを残したりする際に、コミュニティの他のメンバーに表示される情報を管理します。",
	"Profile is used to improve select AWS experiences. <a href=#>Learn more</a>": "プロファイルは、一部の AWS エクスペリエンスを向上させるために使用されます。<a href=#>詳細はこちら</a>",
	"Profile is currently connected to select experiences, which includes <a href=#1>Builder Center</a>, <a href=#2>AWS Blogs</a>, <a href=#3>AWS Startups</a>, select forms and surveys on AWS Pulse, and select online webinar registrations and content downloads. ": "プロファイルは現在、<a href=#1 rel=\"noopener noreferrer\" target=\"_blank\">Builder Center</a> や <a href=#2 rel=\"noopener noreferrer\" target=\"_blank\">AWS ブログ</a> や <a href=#3 rel=\"noopener noreferrer\" target=\"_blank\">AWS Startups</a> を含む一部のエクスペリエンス、AWS Pulse の一部のフォームやアンケート、一部のオンラインウェビナー登録やコンテンツのダウンロードに接続されています。",
	"You can access and update your profile at anytime by going to <a href=#>Profile</a>.": "<a href=#>プロファイル</a>にアクセスして、自分のプロファイルをいつでも確認およびアップデートできます。",
	"There are unsaved changes in the <a href=\"#\">{{profile}}</a> section. Would you like to save or discard?": "<a href=\"#\">{{profile}}</a> セクションに保存されていない変更があります。保存しますか? 破棄しますか?",
	or: "または",
	"browse files": "ファイルを参照",
	"Claim your alias": "エイリアスを取得する",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias cannot be changed after claiming.": "あなたのエイリアスは、コミュニティの全メンバーに表示され、他の開発者があなたとつながる方法となります。エイリアスは取得後に変更することはできません。",
	"Enter your alias": "エイリアスを入力してください",
	"Are you sure you want to claim? This action cannot be undone.": "本当に取得しますか？この操作は取り消せません。",
	Claim: "取得する",
	Claimed: "取得済み",
	"Checking availability": "利用可能性を確認中",
	Claiming: "取得中",
	"Alias must be 3 to 19 characters.": "エイリアスは3〜19文字である必要があります。",
	"Alias must only contain alphanumeric characters (a-z, 0-9).": "エイリアスは英数字（a-z、0-9）のみを含む必要があります。",
	"Alias is already claimed.": "このエイリアスは既に取得されています。",
	"Unable to save your content.": "コンテンツを保存できません。",
	"Your alias will be visible to all members of our community and is how other builders connect with you. Your alias <b>cannot</b> be changed after claiming.": "あなたのエイリアスは、コミュニティの全メンバーに表示され、他の開発者があなたとつながる方法となります。エイリアスは取得後に<b>変更できません</b>。",
	"Your alias must be 3 to 19 alphanumeric characters (contains only a-z, 0-9) and not violate our <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">Terms and Services</a>.": "エイリアスは3〜19文字の英数字（a-z、0-9のみ）で、<a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">利用規約</a>に違反しないものである必要があります。",
	"Please ensure all fields adhere to our <a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">Code of Conduct</a> before trying again.": "再試行する前に、すべてのフィールドが<a class=\"link\" href=\"https://aws.amazon.com/codeofconduct/\" rel=\"noopener noreferrer\" target=\"_blank\">行動規範</a>に準拠していることを確認してください。",
	"If you're still having trouble, feel free to <a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">contact us</a> for assistance.": "まだ問題がある場合は、お気軽に<a class=\"link\" href=\"https://pulse.aws/application/V5ZJLDOL?p=0\" rel=\"noopener noreferrer\" target=\"_blank\">お問い合わせ</a>ください。",
	"Having trouble saving content?": "コンテンツの保存に問題がありますか？",
	"Checking alias availability was not successful. Please try again.": "エイリアスの利用可能性の確認に失敗しました。もう一度お試しください。",
	"This field contains invalid characters.": "このフィールドに無効な文字が含まれています。",
	"Select up to 10 interests": "興味のある項目を最大10個まで選択",
	"Must be 7-15 digits.": "7〜15桁である必要があります。",
	"Invalid postal code. Postal codes may include only letters (A-Z and a-z), numbers (0-9), dashes (-), and spaces.": "郵便番号が無効です。郵便番号には文字（A-Zとa-z）、数字（0-9）、ハイフン（-）、スペースのみを含めることができます。",
	"This name is not valid. Names can include only letters (A-Z and a-z), numbers (0-9), dashes (-), and periods (.).": "この名前は無効です。名前には文字（A-Zとa-z）、数字（0-9）、ハイフン（-）、ピリオド（.）のみを含めることができます。",
	"Invalid email address": "無効なメールアドレス",
	"Must be 64 characters or less": "64文字以下である必要があります",
	"Must be 100 characters or less": "100文字以下である必要があります",
	"2 more interests remaining.": "あと2つ選択できます。",
	"1 more interest remaining.": "あと1つ選択できます。",
	"You've reached the maximum number of interests. To add others, please remove an existing item.": "興味のある項目の最大数に達しました。他の項目を追加するには、既存の項目を削除してください。",
	"Work city": "勤務先の市",
	"Work postal code": "勤務先の郵便番号",
	"I agree to the terms of the <a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS Customer Agreement</a> and the <a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">Statement on the Collection and Use of Personal Information.</a>": "<a class=\"link\" href=\"https://aws.amazon.com/agreement/\" target=\"_blank\" rel=\"noopener noreferrer\">AWS カスタマーアグリーメント</a> 、および<a class=\"link\" href=\"https://d1.awsstatic.com/onedam/marketing-channels/website/aws/en_US/builder-profile/approved/StatementontheCollectionandUseofPersonalInformation_EN.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">個人情報の収集と使用に関するステートメント</a> の条件に同意します。",
	Emails: "メール",
	"AWS Builder ID": "AWS ビルダーID",
	"Additional emails let you use different email addresses for select AWS experiences, while keeping your AWS Builder ID email for sign-in.": "追加のメールアドレスを使用すると、サインインには AWS ビルダーID のメールアドレスを使用しながら、選択した AWS エクスペリエンスには異なるメールアドレスを使用できます。",
	Personal: "個人用",
	Business: "ビジネス用",
	None: "なし",
	"Verify email": "メールを確認",
	Unverified: "未確認",
	"Add email": "メールを追加",
	"Add an email address": "メールアドレスを追加",
	"Enter verification code": "確認コードを入力",
	"A 6-digit verification code has been sent to <span class=\"font-bold\">{{email}}</span>. Please enter it below to confirm your email address.": "6桁の確認コードが <span class=\"font-bold\">{{email}}</span> に送信されました。以下に入力してメールアドレスを確認してください。",
	"Verification limit reached": "確認回数の上限に達しました",
	"You've made the maximum number of requests allowed today. Please try again after 24 hours.": "本日許可されている最大リクエスト数に達しました。24時間後に再試行してください。",
	Okay: "了解",
	"Delete Email": "メールを削除",
	"Are you sure you want to remove your email?": "メールを削除してもよろしいですか？",
	"Please type <span class=\"font-bold\">{{email}}</span> to continue with removal:": "削除を続行するには <span class=\"font-bold\">{{email}}</span> と入力してください：",
	"Didn't receive a code?": "コードが届きませんでしたか？",
	"Request a new code.": "新しいコードを要求する。",
	"Additional emails": "追加メール",
	Type: "種類",
	Skip: "スキップ",
	Submit: "送信",
	"Emails are different": "メールが異なります",
	"Manage my AWS Builder ID": "AWS ビルダーID を管理",
	"Your email address that you use to sign in and access different AWS experiences.": "サインインして様々な AWS エクスペリエンスにアクセスするために使用するメールアドレス。",
	"Email address": "メールアドレス",
	"Email type": "メールタイプ",
	"AWS Builder ID email": "AWS Builder ID メール",
	"If you did not receive an email, please check your spam or junk folder.": "メールが届かない場合は、迷惑メールフォルダをご確認ください。",
	"No additional emails added.": "追加のメールはありません。",
	"Please enter a verification code.": "確認コードを入力してください。",
	"Verification code must be at least 6 characters": "確認コードは6文字以上である必要があります",
	"Federate email": "Federate メール",
	"This information will update existing public details that other members in the community will see across <a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>, <a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a>, and comments on <a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >AWS Blogs</a>. Please make sure to follow <a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >code of conduct</a> when saving your community information.": "この情報により、<a class='link' href='https://repost.aws' rel='noopener noreferrer' target='_blank' >re:Post</a>、<a class='link' href='https://builder.aws.com' rel='noopener noreferrer' target='_blank' >Builder Center</a>、<a href='https://aws.amazon.com/blogs/' class='link' rel='noopener noreferrer' target='_blank' >Amazon Web Services ブログ</a>でコミュニティの他のメンバーに表示される既存の公開情報が更新されます。コミュニティ情報を保存する際は、必ず <a href='https://aws.amazon.com/codeofconduct/' class='link' rel='noopener noreferrer' target='_blank' >AWS 行動規範</a>に従ってください。",
	"Display country": "表示される国",
	"Display state": "表示される州",
	Headline: "見出し",
	"Email marketing preferences": "E メールマーケティングの設定",
	"Select a verified email to manage your email marketing preferences.": "検証済みの E メールを選択して E メールマーケティング設定を管理します。",
	Manage: "管理",
	"Email preferences": "E メールの設定"
};
var jaJP = {
	translation: translation
};

export { jaJP as default, translation };
